import React, { FC, useEffect, useState, useRef } from 'react';
import TableSimple from 'src/components/TableSimple';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { ProductRelation2Type } from 'src/types/product';
import { SelectRowType, TableColumnType, TableRowType } from 'src/types/table';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import ConfirmDialog, { ConfirmDialogStatePropsType } from 'src/components/ConfirmDialog';

const allColumns: TableColumnType[] = [
    {
        key: 'SKU',
        label: 'SKU',
        defaultShow: true,
    },
    {
        key: 'NAME',
        label: 'name',
        defaultShow: true,
    },
    {
        key: 'PRODUCT_TYPE',
        label: 'productType',
        type: 'select',
        selectOption: 'productTypeCodes',
        defaultShow: true,
    },
    {
        key: 'TYPE',
        label: 'type',
        type: 'select',
        selectOption: 'productRelationCodes',
        defaultShow: true,
    },
];

type ProductRelationsListType = {
    ID_PRODUCT_1?: number;
    TYPE?: string;
    NAME?: string;
    PRODUCT_TYPE?: string;
    SKU?: string;
    ID?: number;
};

type ProductRelationsPropsType = {
    data?: ProductRelation2Type[];
    productTypeCodes: ConstantsCodeType[];
    productRelationCodes: ConstantsCodeType[];
    onChange: (value: any) => void;
    disableEdit?: boolean;
};

const ProductRelations: FC<ProductRelationsPropsType> = (props) => {
    const formRef = useRef<HTMLFormElement>(null);

    const [data, setData] = useState<ProductRelationsListType[]>([]);
    const [selectedRows, setSelectedRows] = useState<SelectRowType[]>([]);
    const [confirmParams, setConfirmParams] = useState<ConfirmDialogStatePropsType | null>(null);

    useEffect(() => {
        if (props.data) {
            setData(
                props.data.map((item) => ({
                    ID: item.ID,
                    ID_PRODUCT_1: item.ID_PRODUCT_1,
                    TYPE: item.TYPE,
                    NAME: item.PRODUCT_1.NAME,
                    PRODUCT_TYPE: item.PRODUCT_1.PRODUCT_TYPE,
                    SKU: item.PRODUCT_1.SKU,
                }))
            );
        }
    }, [props.data]);

    const handleRemoveRow = (row: TableRowType) => {
        props.onChange(props.data?.filter((item) => `${item.ID_PRODUCT_1}${item.TYPE}` !== `${row.ID_PRODUCT_1}${row.TYPE}`));
    };

    const handleRemoveSelectRow = () => {
        setConfirmParams({
            title: translate('productDetail.productRelationstable.confirmRemoveSelectedProducts'),
            content: translate('productDetail.productRelationstable.confirmRemoveSelectedProductsText'),
            action: () => {
                props.onChange(props.data?.filter((item) => !selectedRows.includes(String(item.ID))));
                setSelectedRows([]);
            },
            onCancel: () => {},
        });
    };

    return (
        <form ref={formRef}>
            {!!selectedRows.length && !props.disableEdit && (
                <BodyTopBlock
                    actions={[
                        {
                            icon: <DeleteIcon />,
                            onClick: handleRemoveSelectRow,
                            tooltip: translate('productDetail.productRelationstable.removeSelectedProducts'),
                            hidden: props.disableEdit,
                            variant: 'outlined',
                        },
                    ]}
                />
            )}
            <TableSimple
                rowIdKey="ID"
                rows={data || []}
                columsLabelPrefix="productDetail.productRelationstable"
                allColumns={allColumns}
                initSort={{ column: 'ID', direction: 'ASC', createIdNumber: true }}
                rowActions={
                    props.disableEdit
                        ? undefined
                        : [
                              {
                                  icon: <HighlightOffIcon />,
                                  label: translate('productDetail.productRelationstable.remove'),
                                  onClick: handleRemoveRow,
                              },
                          ]
                }
                selectOptions={{
                    productTypeCodes: props.productTypeCodes,
                    productRelationCodes: props.productRelationCodes,
                }}
                // disableFilter
                maxHeight={'unset'}
                selectedRows={!props.disableEdit ? selectedRows : undefined}
                setSelectedRows={!props.disableEdit ? setSelectedRows : undefined}
            />
            {confirmParams && (
                <ConfirmDialog
                    title={confirmParams.title}
                    content={confirmParams.content}
                    action={confirmParams.action}
                    onCancel={confirmParams.onCancel}
                    onClose={(): any => setConfirmParams(null)}
                />
            )}
        </form>
    );
};

export default ProductRelations;
